import { FloatingCornerElementName, Corner } from '~/models/layout'
import { PageState } from '~/store/modules/shared/page/state'
import { ActionTreeWithRootState } from '~/store/types'
import {
  ADD_BODY_CLASS,
  ADD_CORNER_ELEMENT,
  REMOVE_BODY_CLASS
} from './mutation-types'

export default {
  addCornerElement(
    { commit },
    {
      name,
      corner = Corner.BOTTOM_RIGHT
    }: {
      name: FloatingCornerElementName
      corner: Corner
    }
  ) {
    commit(ADD_CORNER_ELEMENT, { name, corner })
  },
  addBodyClass({ commit, state }, className: string) {
    commit(ADD_BODY_CLASS, className)
    if (process.client && document) {
      document.body.className = state.bodyClasses.join(' ')
    }
  },
  removeBodyClass({ commit, state }, className: string) {
    commit(REMOVE_BODY_CLASS, className)
    if (process.client && document) {
      document.body.className = state.bodyClasses.join(' ')
    }
  }
} as ActionTreeWithRootState<PageState>
